import BaseService from './base.service'

import { getConfigSetup } from '@/utils/utils'
import { KEY_INFO } from '@/constants/store'

interface LoginPayload {
    terminal_id: string
    terminal_pin: string
    login_method: string
    ignore_cache: boolean
}

class AuthService extends BaseService {
    async login(payload: LoginPayload) {
        const configSetup = getConfigSetup()
        const newDate = new Date().valueOf()
        payload.ignore_cache = true
        return this.post(configSetup.apiUrl + `/api/retail/session/login?t=${newDate}`, payload).then((response) => {
            return response.data
        })
    }

    async changePin(oldPin: string, newPin: string, newPinRetype: string) {
        const configSetup = getConfigSetup()

        const payload = {
            old_password: oldPin,
            new_password: newPin,
            new_password_retype: newPinRetype,
            type_of_pass: 'terminal_pin',
        }

        return this.post(`${configSetup.apiUrl}/api/retail/change-password`, payload).then(({ data }) => data)
    }

    async changeTypeFontSize(type: string) {
        const configSetup = getConfigSetup();

        const payload = {
            key: 'font-size',
            value: {
                large: type === KEY_INFO.VALUE_LARGE_INCREASE_FONTSIZE ? 1 : 0,
                normal: type === KEY_INFO.VALUE_NORMAL_INCREASE_FONTSIZE ? 1 : 0,
            },
        };
        return this.post(`${configSetup.apiUrl}/api/retail/cashier/update-retail-cashier-setting`, payload).then(
            ({ data }) => data,
        );
    }
}

export default new AuthService()
